module.exports = __webpack_public_path__ + "static/media/instagram.eedb66e0.svg";